import { LoggedUser, TenantStorage } from '../../session/session-decode';

/** ACCESS_ON/ACCESS_PRO; superusuário nunca é ACCESS. Espelha `isLicencaAccessOnPro`. */
export function isLicencaAccessOnPro(
  user: LoggedUser | null,
  tenant: TenantStorage | null,
): boolean {
  if (user?.superUsuario === true) {
    return false;
  }

  const tipo = tenant?.tipoLicenca;
  return tipo === 'ACCESS_ON' || tipo === 'ACCESS_PRO';
}

export function isContaPacAutonoma(tenant: TenantStorage | null): boolean {
  if (!tenant) {
    return false;
  }

  if (typeof tenant.pacAutonomo === 'boolean') {
    return tenant.pacAutonomo;
  }

  const tipo = tenant.tipoLicenca;
  if (!tipo) {
    return false;
  }

  return String(tipo).toUpperCase() === 'PAC_AUTONOMO';
}
